<template>
  <el-dialog
    :visible.sync="value.visible"
    title="表单信息设置"
    :destroy-on-close="true"
    width="500px"
    @open="onDlgOpen"
    @closed="onDlgClosed"
  >
    <el-form ref="dlgForm" label-position="top" label-width="120px" :model="form">
      <el-form-item label="表单名称" prop="name" :rules="[{required: true, message: '请输入', trigger:'blur'}, { min: 3, max: 50, message: '长度3-50个字', trigger: 'blur' },]">
        <el-input v-model="form.name" placeholder="请输入表单名称" maxlength="100" />
      </el-form-item>

      <el-form-item
        prop="scen"
        label="场景"
        :rules="[{ required: true, message: '请输入', trigger: 'blur' },]"
      >
        <el-select v-model="form.scen" placeholder="请选择" style="width: 100%;">
          <el-option v-for="(item, index) of scenList" :key="index" :label="item.label" :value="item.value">
            <span style="float: left">{{ item.label }}</span>
            <span class="has-text-light is-fs-s" style="float: right;">{{ item.desc }}</span>
          </el-option>
        </el-select>
        <div class="has-text-light is-fs-s">不同场景表单的功能不同，可修改</div>
      </el-form-item>
    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" :loading="$store.state.app.loadingList.includes('updateForm')" @click="onOk">确 定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { update as formUpdate } from '@/api/form'
import config from '@/config/index'

export default {
  name: 'DlgFormGeneralCfg',
  components: {
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        visible: false,
        item: null
      })
    }
  },
  emits: ['ok', 'cancel'],
  data() {
    return {
      form: {},
      isChanged: false,

      scenList: config.scenList
    }
  },
  computed: {
    // val: {
    //   get() {
    //     return this.params;
    //   },
    //   set(v) {
    //     this.$emit("update:params", v);
    //     console.log(v);
    //   },
    // },
  },
  watch: {
    // modelValue: {
    //   // eslint-disable-next-line no-unused-vars
    //   handler(newValue, oldValue) {
    //     this.value =  newValue;
    //   },
    //   deep: true,
    // },
  },
  created() {
  },
  mounted() {

  },

  methods: {
    async onDlgOpen() {
      this.form = this.value.item ? this.value.item : {}
      this.isChanged = false
    },
    async onDlgClosed() {
      this.$emit('closed', this.isChanged)
    },
    async saveData() {
      const res = await formUpdate({
        id: this.form.id,
        name: this.form.name,
        scen: this.form.scen
      }, 'updateForm')
      console.log(res)
      this.$message({
        message: '操作成功',
        type: 'success',
        center: true
      })
      this.isChanged = true
      return res
    },

    onCancel() {
      console.log('cancel')
      this.value.visible = false
      this.$emit('cancel')
    },
    async onOk() {
      const that = this
      console.log('ok')
      await this.$refs['dlgForm'].validate(async(valid, fields) => {
        if (valid) {
          await that.saveData()
          this.value.visible = false
          // eslint-disable-next-line require-atomic-updates
          // that.form = {}
          // that.$emit('ok', this.value)
        } else {
          console.log('error submit!', fields)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
